import React from 'react';
import { isNullOrUndefined } from 'util';

export default class CheckBoxInput extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            checked: this.clearValue(this.props.checked)
        }
    }

    componentWillReceiveProps(newProps) {
        let checked = this.clearValue(newProps.checked);
        this.setState({ checked: checked });
    }

    clearValue(value) {
        if (isNullOrUndefined(value)) {
            return false;
        } else {
            return value === true || value === 1 || value === "true" || value === "1";
        }
    }

    handleInputChanged(e) {
        let checked = e.target.checked;
        this.setState({ checked: checked });
        if (this.props.onChange) {
            this.props.onChange(checked);
        }
    }

    render() {
        return (
            <input type="checkbox"
                id={this.props.id}
                title={this.props.title}
                checked={this.state.checked}
				className={this.props.className}
                onChange={e => this.handleInputChanged(e)}
                disabled={this.props.disabled} />
        );
    }
}


// WEBPACK FOOTER //
// ./App/controls/checkBoxInput.jsx